import { render, staticRenderFns } from "./ItemPrices.vue?vue&type=template&id=3c1bc7ce&scoped=true"
import script from "./ItemPrices.vue?vue&type=script&lang=js"
export * from "./ItemPrices.vue?vue&type=script&lang=js"
import style0 from "./ItemPrices.vue?vue&type=style&index=0&id=3c1bc7ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c1bc7ce",
  null
  
)

export default component.exports